import React from "react";

export default function FilterTabs({ filters = [], activeFilter, onChange }) {
  return (
    <div className="grid w-full max-w-[18rem] grid-cols-3 gap-1.5 rounded-[1.1rem] surface-card p-1.5 shadow-soft sm:inline-flex sm:w-auto sm:max-w-none sm:grid-cols-none sm:flex-nowrap sm:self-start sm:gap-2 sm:rounded-full sm:p-1.5">
      {filters.map((filter) => {
        const isActive = activeFilter === filter.id;
        return (
          <button
            key={filter.id}
            type="button"
            onClick={() => onChange(filter.id)}
            aria-pressed={isActive}
            className={`min-h-9 rounded-full px-3 py-2 text-center text-[10px] font-inter font-black uppercase tracking-[0.18em] transition-all duration-300 sm:min-h-11 sm:px-5 sm:py-2.5 sm:text-xs sm:tracking-[0.24em] ${
              isActive
                ? "bg-[#7D192A] text-white shadow-soft"
                : "text-[#1A1C25] hover:bg-white/80"
            }`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
}
